import { render, staticRenderFns } from "./modalPopup.vue?vue&type=template&id=40b4d0bc"
import script from "./modalPopup.vue?vue&type=script&lang=js"
export * from "./modalPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40b4d0bc')) {
      api.createRecord('40b4d0bc', component.options)
    } else {
      api.reload('40b4d0bc', component.options)
    }
    module.hot.accept("./modalPopup.vue?vue&type=template&id=40b4d0bc", function () {
      api.rerender('40b4d0bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/modalPopup.vue"
export default component.exports